export * from './communication.service';
export * from './core-state.service';
export * from './theme.service';

import { CommunicationService } from './communication.service';
import { CoreStateService } from './core-state.service';
import { ThemeService } from './theme.service';

export const ApplicationServices = [
    CommunicationService,
    CoreStateService,
    ThemeService
];